import { render, staticRenderFns } from "./WfConsumerRecordList.vue?vue&type=template&id=0d15e6b6&scoped=true&"
import script from "./WfConsumerRecordList.vue?vue&type=script&lang=js&"
export * from "./WfConsumerRecordList.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerRecordList.vue?vue&type=style&index=0&id=0d15e6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15e6b6",
  null
  
)

export default component.exports